<template>
  <div class="container">
    <!--v-bind:class="['dockabale-window', getDockState]"-->
    <div class="header-dockabale dir-rtl drag" v-if="title">
      <span class="main-header title padd-l-3 drag-area w-100">
        <!-- <slot name="header" class="main-header"></slot> -->
      </span>
      <div class="icon-pin otz-icon no-bg no-bg" @click="togglePin">
        p
      </div>
      <span class="icon-del icon-close otz-icon no-bg no-bg" @click="closeList"
        >F</span
      >

      <span
        class="icon-general icons"
        @click="closeFunc"
        v-if="canClose == true"
        >t</span
      >
    </div>
    <div class="content h-100">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["dockState", "canClose", "closeFunc", "title"],
  data() {
    return {
      style: "",
      dock: this.dockState,
    };
  },
  computed: {
    getDockState() {
      return this.dock;
    },
    getPinIcon() {
      return this.dock == "dock" ? "s" : "r";
    },
  },
  methods: {
    closeList() {
      this.$emit("close");
      // this.state = false;
    },
    parentList() {
      this.$emit("click");
    },
    setDockState(state) {
      this.dockState = state;
    },
    changeDockState() {
      this.dock = this.dock == "dock" ? "float" : "dock";
      this.$emit("click");
    },
    togglePin() {
      this.$emit("pin");
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  flex-direction: column;
  display: flex;
  height: calc(100% - 0px);
  overflow: hidden;
}
.container {
  height: 100%;
  position: relative;
}
.header-dockabale {
  display: flex;
  height: 22px;
  justify-content: space-between;
  border: 1px solid #dedede;
  .icon-close {
    height: 20px;
    line-height: 20px;
    background-color: #efefef;
    &:hover {
      background-color: #efefef !important;
    }
  }
}
.icons {
  background-color: #efefef;
}
.main-header.drag-area {
  background-image: url(/darg.svg) !important;
  background-repeat: no-repeat;
  background-position: center;
}
.icon-pin {
  font-size: 18px;
  background-color: #efefef;
  position: relative;
  color: #7b7b7b !important;
}
</style>
